import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling

function PrivacyPolicy() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
      <div className="hero-banner">
        <div className="hero-content">
          <h1>{t('privacy_policy')}</h1>
          <p style={{ textAlign: 'justify' }}>{t('privacy_policy_section1')}</p>
        </div>
      </div>

      <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <h3 style={{ color: 'black' }}>{t('privacy_policy_title_par1')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('privacy_policy_par1')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('privacy_policy_title_par2')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('privacy_policy_par2')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('privacy_policy_title_par3')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('privacy_policy_par3')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('privacy_policy_title_par4')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('privacy_policy_par4')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('privacy_policy_title_par5')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('privacy_policy_par5')}</p>
          <br />

          <h3 style={{ color: 'black' }}>{t('privacy_policy_title_par6')}</h3>
          <p style={{ textAlign: 'justify' }}>{t('privacy_policy_par6')}</p>
          <br />

          
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
